<loading></loading>
<div class="row">
    <div class="col-xxl-2 col-xl-3" *ngIf="main">
        <div class="kt-portlet mr-2" [class.focus]="main.focus">
            <div class="kt-portlet__body bold kt-label-font-color-1">
                <div class="d-flex align-items-center pb-3 border-bottom" *ngIf="!main.focus">
                    <button class="btn btn-sm btn-outline-secondary back mr-2" (click)="goBack()">
                        <span class="fa fa-angle-left"></span></button>
                    <div>
                        <span class="cursor-pointer" (click)="goBack()">ADVANCED REORDER</span> > <span class="strong">{{main?.data.sku}}</span> > Subs
                    </div>
                </div>
                <div class="pt-3">
                    <div class="text-dark strong mb-2">Main item sub total</div>
                    <div>
                        <img [src]="imageUrl + main.data.productId" style="max-height: 56px; max-width: 56px;" class="hr mr-3">
                    </div>
                    <div>
                        <div class="py-2 d-flex align-items-center">
                            SKU: <span class="ml-1 strong text-dark">{{main.data.sku}}</span>
                            <div class="ml-3 dark-badge">Main</div>
                        </div>
                        <div>{{main.data.description | slice:0:40}}</div>
                    </div>
                </div>
                <div class="py-2 border-bottom">
                    <div class="mb-1">Available Supply</div>
                    <ng-container *ngIf="totalInventory(main) + getTotalRealtime(main) > 0">
                        <span class="strong text-dark">{{totalInventory(main) + getTotalRealtime(main) | number:'1.0-0' }}</span>
                        <span class="right strong text-dark">Till {{main.supplyTill | date}}</span>
                    </ng-container>
                    <ng-container *ngIf="totalInventory(main) + getTotalRealtime(main) <= 0">
                        <span class="strong text-danger">Out of stock</span>
                    </ng-container>
                </div>
                <div class="py-2" [formGroup]="formGroup">
                    <div class="kt-label-font-color-1 mb-1">Suppliers
                        <i class="fa fa-question fa-qus"
                            ngbPopover="Select a supplier, not necessarily the one assigned to this item"
                            container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                    </div>
                    <ng-select class="supplier" [items]="main.suppliers" bindLabel="name" bindValue="id" [virtualScroll]="true"
                        formControlName="supplierId" appendTo="body" groupBy="type">
                    </ng-select>
                </div>
                <div class="pt-2 pb-3">
                    <div class="kt-label-font-color-1 mb-1">Lead time
                        <i class="fa fa-question fa-qus"
                            ngbPopover="Select the number of days it takes to receive your order from your supplier."
                            container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                    </div>
                    <div class="d-flex flex-wrap leadtime">
                        <button [class.selected]="main.shipBy == 'bySea'" class="mr-2 mb-1 btn btn-sm p-1 btn-secondary"
                            (click)="setDayToArrive(this.main, 'bySea', main.supplier?.bySea)">
                            <i class="fa fa-ship"></i>{{main.supplier?.bySea}} Days</button>
                        <button [class.selected]="main.shipBy == 'byAir'" class="mr-2 mb-1 btn btn-sm p-1 btn-secondary"
                            (click)="setDayToArrive(this.main, 'byAir', main.supplier?.byAir)">
                            <i class="fa fa-plane"></i>{{main.supplier?.byAir}} Days</button>
                        <button [class.selected]="main.shipBy == 'other'" class="mb-1 btn btn-sm p-1 btn-secondary"
                            (click)="setDayToArrive(this.main, 'other', 0)">Other</button>
                    </div>
                    <div class="mt-3" *ngIf="main.shipBy == 'other'">
                        <div class="input-group input-group-sm">
                            <input type="number" #subsDayToArrive class="form-control" value="0" min="0"
                                (change)="setDayToArrive(this.main, 'other', +subsDayToArrive.value)">
                            <div class="input-group-append">
                                <span class="input-group-text">Days</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-auto border-top pt-2">
                    <div *ngIf="main.data.price" class="right strong">{{main.data.price | currency}}</div>
                    <div>Cost per piece</div>
                </div>
                <div>
                    <div *ngIf="main.data.pricePlus" class="right strong">{{main.data.pricePlus | currency}}</div>
                    <div>Cost + Shipping</div>
                </div>
                <div class="pt-1 mt-2 border-top right-column d-flex flex-column" [formGroup]="main.formGroup">
                    <span class="d-inline-block pt-2 strong text-dark medium-text" *ngIf="!main.showLocation">Calculations</span>
                    <ng-container *ngIf="!main.focus">
                        <div class="py-1 text-dark">
                            Total units sold in <span class="text-dark">{{totalDays(main) | number}}</span> days
                            <span class="right strong text-dark">{{ totalUnits(main) | number:'1.0-0'}}</span>
                        </div>
                        <div class="py-1">
                            Adjust by in stock Avg.
                            <span class="right strong text-dark">{{avgInStock(main) | percent}}</span>
                        </div>
                        <div class="py-1">
                            Adjust by Buy Box Avg.
                            <span class="right strong text-dark">{{avgBuyBox(main) | percent}}</span>
                        </div>
                        <div class="border-bottom my-2"></div>
                        <div class="py-1 text-dark">
                            Avg. per day / total days
                            <span class="right strong text-dark">{{mainTotalOrders() / totalDays(main) | number:'1.0-1'}} x {{ main.data.orderFor || main.totalOrderFor }}</span>
                        </div>
                        <div class="py-1 d-flex">
                            <span>Quantity needed</span>                    
                            <span class="ml-auto text-dark strong">{{ mainTotalOrders(true, false) | number:'1.0-1'}}</span>
                        </div>
                        <div class="py-1" *ngIf="main.formGroup.value.minusPOs && main.data.openPurchaseOrders">
                            Open purchase orders
                            <span class="right strong text-dark">{{-main.data.openPurchaseOrders | number}}</span>
                        </div>
                        <div class="py-1" *ngIf="inventory(main) && main.formGroup.value.minusInventory">
                            Inventory
                            <span class="right strong text-dark">{{-inventory(main) | number}}</span>
                        </div>
                        <div class="py-1" *ngIf="main.formGroup.value.minusOverstockedStoreInventory && main.orderDetails?.overstockedStoresInventory">
                            Overstocked Store Inventory
                            <span class="right strong text-dark">{{-main.orderDetails?.overstockedStoresInventory | number}}</span>
                        </div>
                        <div class="py-1 d-flex" *ngIf="main.data.adjustment">
                            Adjustment of
                            <span class="ml-1 text-dark strong">{{main.data.adjustment | percent}}</span>
                            <span class="ml-auto text-dark strong">
                                {{main.data.adjustment > 0 ? '+' : ''}}{{((main.data.addedQuantity || main.totalReorder) / (1 + main.data.adjustment)) * main.data.adjustment | number}}
                            </span>
                        </div>
                        <div class="py-1" *ngIf="getTotalAdjustment(main)">
                            <span class="kt-label-font-color-1">Subs adjustments</span>
                            <span class="right strong">
                                {{getTotalAdjustment(main) | number}}
                            </span>
                        </div>
                        <div class="py-1 d-flex" *ngIf="main.data.manualEntry">
                            <span class="kt-label-font-color-1">Manual entry</span>
                            <span class="ml-auto text-dark strong">
                                {{main.data.manualEntry < 0 ? '-' : '+'}}{{main.data.manualEntry | number}}</span>
                        </div>
                        <div class="py-1" *ngIf="getTotalManualEntry(main)">
                            <span class="kt-label-font-color-1">Subs manual entries</span>
                            <span class="right strong">
                                {{getTotalManualEntry(main) | number}}
                            </span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="main.focus && !main.showLocation">
                        <div class="py-1 d-flex">
                            <span>Total days</span>
                            <span class="ml-auto text-dark strong">{{totalDays(main) | number}}</span>
                        </div>
                        <div class="py-1 d-flex">
                            <span>Total units sold</span>
                            <span class="ml-auto text-dark strong">{{totalUnits(main) | number}}</span>
                        </div>
                        <div class="py-1 mt-2">
                            Adjustments
                        </div>
                        <div class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                            [class.selected]="main.formGroup.value.outOfStock"
                            (click)="main.formGroup.controls.outOfStock.setValue(!main.formGroup.value.outOfStock)">
                            <div class="d-flex">Adjust by in stock Avg.
                                <i class="ml-auto fa" [class.kt-font-brand]="!main.formGroup.value.outOfStock"
                                    [ngClass]="main.formGroup.value.outOfStock ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </div>
                            <div class="text-dark strong">{{avgInStock(main) | percent}}</div>
                        </div>
                        <div class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                            [class.selected]="main.formGroup.value.buyBox"
                            (click)="main.formGroup.controls.buyBox.setValue(!main.formGroup.value.buyBox)">
                            <div class="d-flex">Adjust by Buy Box Avg.
                                <i class="ml-auto fa" [class.kt-font-brand]="!main.formGroup.value.buyBox"
                                    [ngClass]="main.formGroup.value.buyBox ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </div>
                            <div class="text-dark strong">{{avgBuyBox(main) | percent}}</div>
                        </div>
                        <div class="py-1">
                            <div>Adjustment of {{main.data.adjustment | percent}}</div>
                            <div class="d-flex adjust my-1">
                                <button class="btn btn-sm rounded-3" [disabled]="main.adjSign == '-'"
                                    (click)="main.adjSign = '-';refreshAdjustment(main);"
                                    [ngClass]="'btn-outline-' + (main.adjSign == '-' ? 'brand' : 'secondary')">-</button>
                                <button class="btn btn-sm rounded-3 ml-1" [disabled]="main.adjSign != '-'"
                                    (click)="main.adjSign = '+';refreshAdjustment(main);"
                                    [ngClass]="'btn-outline-' + (main.adjSign == '-' ? 'secondary' : 'brand')">+</button>
                                <input class="form-control form-control-sm rounded-3 ml-2" type="number" formControlName="adjustment">
                            </div>
                        </div>
                        <div class="py-1 d-flex">
                            <span>Avg. per day</span>                    
                            <span class="ml-auto text-dark strong">{{mainTotalOrders(true, false) / totalDays(main) | number:'1.0-1'}}</span>
                        </div>
                        <div class="border-bottom my-2"></div>
                        <div class="p-1 text-dark strong">
                            To order
                        </div>
                        <div class="py-1 d-flex">
                            <span>Quantity needed</span>                    
                            <span class="ml-auto text-dark strong">{{ mainTotalOrders(true, false) | number:'1.0-1'}}</span>
                        </div>
                        <div class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                            [class.selected]="main.formGroup.value.minusPOs"
                            (click)="main.formGroup.controls.minusPOs.setValue(!main.formGroup.value.minusPOs)">
                            <div class="d-flex">Open purchase orders
                                <i class="ml-auto fa" [class.kt-font-brand]="!main.formGroup.value.minusPOs"
                                    [ngClass]="main.formGroup.value.minusPOs ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </div>
                            <div class="text-dark strong">{{-main.data.openPurchaseOrders || 0 | number}}</div>
                        </div>
                        <div class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                            [class.selected]="main.formGroup.value.minusInventory"
                            (click)="main.formGroup.controls.minusInventory.setValue(!main.formGroup.value.minusInventory)">
                            <div class="d-flex">Inventory
                                <i class="ml-auto fa" [class.kt-font-brand]="!main.formGroup.value.minusInventory"
                                    [ngClass]="main.formGroup.value.minusInventory ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </div>
                            <div class="text-dark strong">{{-inventory(main) | number}}</div>
                        </div>
                        <div class="p-1 kt-font-brand cursor-pointer" (click)="main.showLocation = true">
                            Select locations
                        </div>
                        <div class="py-1">
                            <div>Manual entry</div>
                            <div class="d-flex adjust my-1">
                                <button class="btn btn-sm rounded-3" [disabled]="main.meSign == '-'"
                                    (click)="main.meSign = '-';refreshAdjustment(main);"
                                    [ngClass]="'btn-outline-' + (main.meSign == '-' ? 'brand' : 'secondary')">-</button>
                                <button class="btn btn-sm rounded-3 ml-1" [disabled]="main.meSign != '-'"
                                    (click)="main.meSign = '+';refreshAdjustment(main);"
                                    [ngClass]="'btn-outline-' + (main.meSign == '-' ? 'secondary' : 'brand')">+</button>
                                <input class="form-control form-control-sm rounded-3 ml-2" type="number" formControlName="manualEntry">
                            </div>
                        </div>
                    </ng-container>    
                    <ng-container *ngIf="main.showLocation">
                        <div class="pt-1 pb-2 d-flex align-items-center border-bottom">
                            <button class="btn btn-sm btn-outline-secondary rounded-3 mr-2"
                                (click)="main.showLocation = false"><i class="fa fa-angle-left pr-0"></i></button>
                            Select Inventory locations
                        </div>
                        <div class="py-2 d-flex">
                            <span class="kt-label-font-color-1">On hand Inventory</span>
                            <div class="ml-auto kt-font-brand">
                                <label class="mb-0 kt-checkbox kt-checkbox--brand"
                                    [class.kt-checkbox--solid]="main.formGroup.value.minusInventory">
                                    <input type="checkbox" [checked]="allSelected(main.locationsFormGroup)"
                                        (click)="includeAllLocations($event, main)">Include All
                                    <span></span>
                                </label>
                            </div>
                        </div>
                        <div *ngFor="let location of locations.getAll()"
                            class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                            [class.selected]="main.locationsFormGroup.value[location.id]"
                            (click)="main.locationsFormGroup.controls[location.id].setValue(!main.locationsFormGroup.value[location.id])">
                            <div class="d-flex">{{location.name}}
                                <i class="ml-auto fa" [class.kt-font-brand]="!main.locationsFormGroup.value[location.id]"
                                    [ngClass]="main.locationsFormGroup.value[location.id] ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                            </div>
                            <div class="text-dark strong">{{-main.data.locations.get(location.id) || 0 | number}}</div>
                        </div>
                    </ng-container>
                    <div class="my-2"></div>
                    <button *ngIf="!main.focus" class="btn btn-sm btn-outline-secondary rounded-3 mt-auto"
                        (click)="modifyCal(main)">Modify calculation</button>    
                    <ng-container *ngIf="!main.showLocation">
                        <div class="my-2 p-3 selectable d-flex border rounded-3" [class.selected]="main.data.addedQuantity">
                            <div>
                                <div>Total units to order</div>
                                <div class="text-dark strong">{{main.data.addedQuantity || main.totalReorder | number}}</div>
                            </div>
                            <div class="ml-auto">
                                <button class="btn btn-sm btn-brand strong rounded-3" type="button" (click)="addToOrder(main)"
                                    [disabled]="!main.data.addedQuantity && main.totalReorder <= 0? true : null">
                                    <i class="fa" [ngClass]="main.data.addedQuantity ? 'fa-check' : 'fa-plus'"></i>
                                    Add{{main.data.addedQuantity ? 'ed' : ''}}
                                </button>
                            </div>
                        </div>
                        <div class="pt-2">
                            Total cost
                            <span class="right strong text-dark">{{(main.data.addedQuantity || main.totalReorder) * main.data.pricePlus | currency}}</span>
                        </div>
                        <div class="pt-2" *ngIf="main.cbm">
                            Total CBM
                            <span class="right strong text-dark">{{main.data.cbm * (main.data.addedQuantity || main.totalReorder) | number:'1.0-2'}}</span>
                        </div>
                    </ng-container>
                    <button *ngIf="main.focus && !main.showLocation" class="btn btn-sm btn-brand rounded-3 mt-2"
                        (click)="closeCal(main)">Done</button>
                    <button *ngIf="main.focus && !main.showLocation" class="btn btn-sm btn-secondary rounded-3 mt-2"
                        (click)="closeCal(main, true)">Cancel</button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xxl-10 col-xl-9">
        <div class="row">
          <div class="col-sm-9">
              <div class="kt-portlet kt-portlet--height-fluid">
                  <div class="kt-portlet__body">
                      <div class="row" *ngIf="!headerExpanded">
                          <div class="col-lg-4 col-md-6 d-flex">
                              <div class="my-auto mr-2">REORDER <span class="text-nowrap">SETTINGS
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Set up the default reorder rule that will apply to all items. 
                                          You can override this rule by selecting a different rule on each item separately. 
                                          When you are done creating the reorder settings click on “Apply Updates” to save your default reorder rules."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i></span>
                              </div>
                              <div class="d-flex w-100 setting">
                                  <div class="btn-group" ngbDropdown>
                                      <button class="btn btn-outline-secondary" ngbDropdownToggle>
                                          {{ selectedRule?.name }}
                                      </button>
                                      <div class="dropdown-menu" ngbDropdownMenu>
                                          <button ngbDropdownItem *ngFor="let rule of advReorderRules.getAll()"
                                            (click)="selectRule(rule)">{{ rule.name || "Custom" }}
                                          </button>
                                      </div>
                                  </div>
                                  <div class="ml-2 p-2 large-text border rounded" (click)="addNewRule()">
                                      <i class="fa-regular fa-square-plus"></i>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-4 col-md-6 d-flex border-left">
                              <div class="my-auto mr-2 text-nowrap">ORDER FOR
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Select the number of days or the months to reorder for."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                              </div>
                              <range-picker #orderFor1 [addYears]="5" (change)="filterChanged()" class="w-100"></range-picker>
                          </div>
                          <div class="col-lg-4 d-flex border-left justify-content-end">
                              <div class="my-auto mr-2 text-nowrap">BASED ON
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Select the number of days or the months the reorder calculations should be based on."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                              </div>
                              <range-picker #basedOn1 [addYears]="-5" (change)="filterChanged()" class="w-100"></range-picker>
                              <div class="mx-2 border-left"></div>
                              <div class="d-flex expand my-auto">
                                  <button class="btn btn-sm btn-brand mr-2" *ngIf="ruleChanged"
                                      (click)="loadData()">Apply Updates</button>
                                  <button class="btn btn-sm btn-outline-secondary" (click)="openSettings()">
                                      <i class="fa fa-cog pr-0"></i></button>
                                  <button class="btn btn-sm btn-outline-brand ml-1" (click)="toggleHeader()">
                                      <i class="fa-solid fa-chevron-down pr-0"></i></button>
                              </div>
                          </div>
                      </div>
                      <div class="row" *ngIf="headerExpanded">
                          <div class="col-sm-3 heading-flex-main">
                              <div class="mb-3">REORDER SETTINGS
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Set up the default reorder rule that will apply to all items. 
                                          You can override this rule by selecting a different rule on each item separately. 
                                          When you are done creating the reorder settings click on “Apply Updates” to save your default reorder rules."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                              </div>
                              <div class="d-flex w-100 setting">
                                  <div class="btn-group" ngbDropdown>
                                      <button class="btn btn-outline-secondary" ngbDropdownToggle>
                                          {{ selectedRule?.name }}
                                      </button>
                                      <div class="dropdown-menu" ngbDropdownMenu>
                                          <button ngbDropdownItem *ngFor="let rule of advReorderRules.getAll()" (click)="selectRule(rule)">
                                              {{ rule.name || "Custom" }}
                                          </button>
                                      </div>
                                  </div>
                                  <div class="ml-2 p-2 large-text border rounded" (click)="addNewRule()">
                                      <i class="fa-regular fa-square-plus"></i>
                                  </div>
                              </div>
                              <div class="kt-label-font-color-1 pt-2 pb-1">
                                  Apply rule to:
                              </div>
                              <div>
                                  <label class="kt-radio kt-radio--bold kt-margin-b-0 mr-2" [class.kt-radio--brand]="!applyToAll">
                                      <input type="radio" name="apply-to" (click)="!(applyToAll = false); ruleChanged = true;"
                                          [checked]="!applyToAll">Items with no rules<span></span>
                                  </label>
                                  <label class="kt-radio kt-radio--bold kt-margin-b-0" [class.kt-radio--brand]="applyToAll">
                                      <input type="radio" name="apply-to" (click)="applyToAll = true; ruleChanged = true;"
                                          [checked]="applyToAll">All items<span></span>
                                  </label>
                              </div>
                          </div>
                          <div class="col-sm-3 border-left">
                              <div class="mb-3">ORDER SUPPLY FOR
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Select the number of days or the months to reorder for."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                              </div>
                              <range-picker #orderFor2 [addYears]="5" (change)="filterChanged()"></range-picker>
                          </div>
                          <div class="col-sm-3 border-left">
                              <div class="mb-3">BASED ON
                                  <i class="fa fa-question fa-qus"
                                      ngbPopover="Select the number of days or the months the reorder calculations should be based on."
                                      container="body" placement="top" triggers="mouseenter:mouseleave"></i>
                              </div>
                              <range-picker #basedOn2 [addYears]="-5" (change)="filterChanged()"></range-picker>
                          </div>
                          <div class="col-sm-3 border-left d-flex flex-column">
                              <div class="mb-2">
                                  OTHER
                              </div>
                              <div class="d-flex">
                                  <div class="d-flex flex-wrap align-items-center">
                                      <i class="fa-solid fa-warehouse p-1" [class.disabled]="!formGroup.value.minusInventory"></i>
                                      <i class="fa-solid fa-shop-lock p-1" [class.disabled]="!formGroup.value.minusStoreInventory"></i>
                                      <i class="fa-solid fa-shop p-1" [class.disabled]="!formGroup.value.minusOverstockedStoreInventory"></i>
                                      <i class="fa-solid fa-cart-arrow-down p-1" [class.disabled]="!formGroup.value.minusPOs"></i>
                                      <i class="fa-solid fa-chart-simple p-1" [class.disabled]="!formGroup.value.outOfStock"></i>
                                      <i class="fa-solid fa-box p-1" [class.disabled]="!formGroup.value.buyBox"></i>
                                      <span class="text-nowrap mr-2">
                                          <i class="fa-solid p-1" [ngClass]="adjSign=='+' ? 'fa-arrow-up kt-font-success' : 'fa-arrow-down kt-font-danger'"></i>
                                          {{ formGroup.value.adjustment / 100 | percent}}
                                      </span>
                                  </div>
                                  <div class="ml-auto">
                                      <button class="btn btn-sm btn-outline-secondary" (click)="openSettings()">
                                          <i class="fa fa-cog"></i>More settings</button>
                                  </div>
                              </div>
                              <div class="mt-auto d-flex">
                                  <button class="btn btn-sm btn-brand" [disabled]="ruleChanged ? null : true"
                                      (click)="loadData()">Apply Updates</button>
                                  <div class="ml-auto kt-font-brand expand text-nowrap" (click)="toggleHeader()">
                                      Show Less
                                      <button class="btn btn-sm btn-outline-brand"><i class="fa-solid fa-chevron-up pr-0"></i></button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-sm-3">
              <div class="kt-portlet kt-portlet--height-fluid">
                  <div class="kt-portlet__body">
                      <div class="mb-3" *ngIf="headerExpanded">
                          REORDER LIST
                      </div>
                      <div class="text-nowrap">
                          <div class="row" *ngIf="headerExpanded">
                              <div class="col-2">Items</div>
                              <div class="col-2">Vendors</div>
                              <div class="offset-2 col-4">Total</div>
                          </div>
                          <div class="row strong" *ngIf="headerExpanded">
                              <div class="col-2">{{addedReorders?.length || 0 | number}}</div>
                              <div class="col-2">{{vendors || 0 | number}}</div>
                              <div class="offset-2 col-4 large-text">{{totalCost || 0 | currency}}</div>
                          </div>
                          <button class="btn btn-sm btn-brand right mt-2" (click)="order()"
                              [disabled]="addedReorders?.length ? null : true">Continue to reorder</button>
                          <div class="left pt-3 medium-text strong my-auto" *ngIf="!headerExpanded">Total: {{totalCost || 0 | currency}}</div>
                          <button *ngIf="headerExpanded" class="btn btn-sm btn-outline-secondary right mt-2 mr-2" (click)="removeAll()"
                              [disabled]="addedReorders?.length ? null : true">Remove all</button>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="kt-portlet">
                    <div class="kt-portlet__body">
                       <div class="d-flex">
                            <div class="flex-1 border rounded-3 flex flex-nowrap items-center py-2 px-3" style="gap: 0.5rem;">
                                <img src="assets/media/icons/svg/icon-search.svg">
                                <input #searchBox type="text" placeholder="Search..." class="outline-none flex-1" (change)="search($event)">
                                <img src="assets/media/icons/svg/scan-gray-symbol.svg">
                            </div>
                            <div class="btn-group ml-4">
                                <button class="btn btn-outline-secondary" #filterPopup="ngbPopover" container="body"
                                    [ngbPopover]="filtersPopover" [autoClose]="'outside'" placement="bottom">More filters</button>
                                <ng-template #filtersPopover>
                                    <filters [filterOptions]="filterOptions" [selectedFilters]="selectedFilters"
                                        [savedFilters]="allFilters" (closed)="filterPopup.close()"
                                        (applied)="filterPopup.close();applyFilters($event);">
                                    </filters>
                                </ng-template>
                            </div>
                            <div ngbDropdown>
                                <div class="btn-group ml-4">
                                    <button class="btn btn-outline-secondary sort-picker" (click)="sortByDirection()">
                                        <div class="up" [class.off]="data.sort === 'desc'"></div>
                                        <div class="down" [class.off]="data.sort === 'asc'"></div>
                                    </button>
                                    <button class="btn btn-outline-secondary" ngbDropdownToggle>
                                        Sort by: {{truncate(sortTitle, 13)}}</button>
                                    <div ngbDropdownMenu>
                                        <button *ngFor="let option of filterOptions" ngbDropdownItem
                                            (click)="changeSort(option)">{{option.title}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <filters-view class="mt-2" [selectedFilters]="selectedFilters" (removed)="removedFilter($event)">
                        </filters-view>
                        <div class="row strong mt-4">
                            <div class="col-sm-9">Calculation</div>
                            <div class="col-sm-3 pl-5">Subtotal</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngFor="let item of data?.items">
            <ng-container *ngIf="item.formGroup">
                <div class="col-xl-9">
                    <div class="kt-portlet kt-portlet--height-fluid position-relative">
                        <item-options [item]="item" [helper]="this"></item-options>
                        <div class="d-flex align-items-center p-2 pr-4 w-100 border-bottom" style="z-index: 2;">
                            <div>
                                <img [src]="imageUrl + item.data.productId" style="max-height: 46px; max-width: 46px;" class="hr mr-3">
                            </div>
                            <div class="kt-label-font-color-1 bold">
                                SKU: <span class="ml-1 text-dark strong">{{item.data.sku}}</span>
                            </div>
                            <div class="ml-3 dark-badge" *ngIf="main?.data.productId == item.data.productId">Main</div>
                            <div class="kt-label-font-color-1 p-3 bold">
                                Fr: <span class="text-dark strong">{{item.data.fraction}}</span>
                            </div>
                            <div class="p-3 bold">
                                <a class="kt-font-brand cursor-pointer" (click)="loadListings(item)">
                                    View Listings <span class="subs">{{item.data.listings}}</span>
                                </a>
                            </div>
                            <div class="ml-auto kt-label-font-color-1 p-3 kt-margin-r-40">
                                Cost per pack <span class="text-dark strong">{{item.data.pricePlus * item.data.fraction | currency}}</span>
                            </div>
                        </div>
                        <div class="h-100" [class.focus]="item.focus"
                            [ngStyle]="{'overflow-x': item.data.hasSubRule ? 'hidden' : 'auto'}">
                            <monthly-picker [item]="item" [helper]="this">
                            </monthly-picker>    
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="kt-portlet kt-portlet--height-fluid right-column focus" *ngIf="item.focus">
                        <div class="kt-portlet__body bold h-100" [formGroup]="item.formGroup">
                            <ng-container *ngIf="!item.showLocation">
                                <ng-select [items]="advReorderRules.getAll()" bindLabel="name" bindValue="id"
                                    formControlName="reorderRuleId" appendTo="body" [virtualScroll]="true">
                                </ng-select>
                                <div class="mt-2 py-1 text-dark strong">
                                    Sales report total
                                </div>
                                <div class="py-1 d-flex">
                                    <span>Total days</span>
                                    <span class="ml-auto text-dark strong">{{totalDays(item) | number}}</span>
                                </div>
                                <div class="py-1 d-flex">
                                    <span>Total {{showPacks ? 'pack' : 'unit'}}s sold</span>
                                    <span class="ml-auto text-dark strong">{{showQuantity(item, item.data.hasSubRule ? item.data.orders : totalUnits(item)) | number}}</span>
                                </div>
                                <div class="py-1 mt-2">
                                    Adjustments
                                </div>
                                <div class="my-1 p-2 selectable border rounded-3 cursor-pointer" *ngIf="!item.data.hasSubRule"
                                    [class.selected]="item.formGroup.value.outOfStock"
                                    (click)="item.formGroup.controls.outOfStock.setValue(!item.formGroup.value.outOfStock)">
                                    <div class="d-flex">Adjust by in stock Avg.
                                        <i class="ml-auto fa" [class.kt-font-brand]="!item.formGroup.value.outOfStock"
                                            [ngClass]="item.formGroup.value.outOfStock ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                    </div>
                                    <div class="text-dark strong">{{avgInStock(item) | percent}}</div>
                                </div>
                                <div class="my-1 p-2 selectable border rounded-3 cursor-pointer" *ngIf="!item.data.hasSubRule"
                                    [class.selected]="item.formGroup.value.buyBox"
                                    (click)="item.formGroup.controls.buyBox.setValue(!item.formGroup.value.buyBox)">
                                    <div class="d-flex">Adjust by Buy Box Avg.
                                        <i class="ml-auto fa" [class.kt-font-brand]="!item.formGroup.value.buyBox"
                                            [ngClass]="item.formGroup.value.buyBox ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                    </div>
                                    <div class="text-dark strong">{{avgBuyBox(item) | percent}}</div>
                                </div>
                                <div class="py-1 d-flex">
                                    <span>Avg. per day</span>
                                    <span class="ml-auto text-dark strong">{{showQuantity(item, item.data.hasSubRule ? item.data.orders : totalOrders(item)) / totalDays(item) | number:'1.0-1'}}</span>
                                </div>
                                <div class="py-1 d-flex" *ngIf="main?.productId != item?.productId">
                                    <span>Fraction</span>
                                    <span class="ml-auto text-dark strong">{{item.data.fraction || 1 | number}}</span>
                                </div>
                                <div class="border-bottom my-2"></div>
                                <div class="p-1 text-dark strong">
                                    To order
                                </div>
                                <div class="py-1 d-flex">
                                    <span>Quantity needed</span>
                                    <span class="ml-auto text-dark strong">
                                        {{ showQuantity(item, ((item.data.hasSubRule ? item.data.reorderRaw : totalOrders(item)) / totalDays(item)) * (item.formGroup.value.totalDays || item.data.orderFor || item.totalOrderFor)) | number:'1.0-1'}}
                                    </span>
                                </div>
                                <div class="my-1 p-2 selectable border rounded-3 cursor-pointer" *ngIf="!item.data.hasSubRule"
                                    [class.selected]="item.formGroup.value.minusStoreInventory"
                                    (click)="item.formGroup.controls.minusStoreInventory.setValue(!item.formGroup.value.minusStoreInventory)">
                                    <div class="d-flex">Store Inventory
                                        <i class="ml-auto fa" [class.kt-font-brand]="!item.formGroup.value.minusStoreInventory"
                                            [ngClass]="item.formGroup.value.minusStoreInventory ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                    </div>
                                    <div class="text-dark strong">{{-(item.usedRealtime || item.totalRealtime || 0) | number}}</div>
                                </div>
                                <div *ngIf="!item.data.hasSubRule" class="p-1 kt-font-brand cursor-pointer"
                                    (click)="item.showLocation = true">Select locations</div>
                                <div class="py-1">
                                    <div>Adjustment of {{item.data.adjustment | percent}}</div>
                                    <div class="d-flex adjust my-1">
                                        <button class="btn btn-sm rounded-3" [disabled]="item.adjSign == '-'"
                                            (click)="item.adjSign = '-';refreshAdjustment(item)"
                                            [ngClass]="'btn-outline-' + (item.adjSign == '-' ? 'brand' : 'secondary')">-</button>
                                        <button class="btn btn-sm rounded-3 ml-1" [disabled]="item.adjSign != '-'"
                                            (click)="item.adjSign = '+';refreshAdjustment(item);"
                                            [ngClass]="'btn-outline-' + (item.adjSign == '-' ? 'secondary' : 'brand')">+</button>
                                        <input class="form-control form-control-sm rounded-3 ml-2" type="number" formControlName="adjustment">
                                    </div>
                                </div>
                                <div class="py-1">
                                    <div>Manual entry</div>
                                    <div class="d-flex adjust my-1">
                                        <button class="btn btn-sm rounded-3" [disabled]="item.meSign == '-'"
                                            (click)="item.meSign = '-';refreshAdjustment(item);"
                                            [ngClass]="'btn-outline-' + (item.meSign == '-' ? 'brand' : 'secondary')">-</button>
                                        <button class="btn btn-sm rounded-3 ml-1" [disabled]="item.meSign != '-'"
                                            (click)="item.meSign = '+';refreshAdjustment(item);"
                                            [ngClass]="'btn-outline-' + (item.meSign == '-' ? 'secondary' : 'brand')">+</button>
                                        <input class="form-control form-control-sm rounded-3 ml-2" type="number" formControlName="manualEntry">
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="item.showLocation">
                                <div class="pb-2 d-flex align-items-center border-bottom">
                                    <button class="btn btn-sm btn-outline-secondary rounded-3 mr-2"
                                        (click)="item.showLocation = false"><i class="fa fa-angle-left pr-0"></i></button>
                                    Select Inventory locations
                                </div>
                                <div class="py-2 d-flex">
                                    <span class="kt-label-font-color-1">Store Inventory</span>
                                    <div class="ml-auto kt-font-brand">
                                        <label class="mb-0 kt-checkbox kt-checkbox--brand"
                                            [class.kt-checkbox--solid]="item.formGroup.value.minusStoreInventory">
                                            <input type="checkbox" [checked]="allSelected(item.storesFormGroup)"
                                                (click)="includeAllStores($event, item)">Include All
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                                <div *ngFor="let store of stores.getAll()"
                                    class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                                    [class.selected]="item.storesFormGroup.value[store.id]"
                                    (click)="item.storesFormGroup.controls[store.id].setValue(!item.storesFormGroup.value[store.id])">
                                    <div class="d-flex">{{store.name}}
                                        <i class="ml-auto fa" [class.kt-font-brand]="!item.storesFormGroup.value[store.id]"
                                            [ngClass]="item.storesFormGroup.value[store.id] ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                    </div>
                                    <div class="text-dark strong">{{-(item.storeUsedRealtime.get(store.id) !== undefined ? item.storeUsedRealtime.get(store.id) : (getRealtime(item, store.id) || 0)) | number}}</div>
                                </div>
                                <div class="py-2 d-flex">
                                    <span class="kt-label-font-color-1">Overstocked Inventory</span>
                                    <div class="ml-auto kt-font-brand">
                                        <label class="mb-0 kt-checkbox kt-checkbox--brand"
                                            [class.not-allowed]="isOverstockedDisabled(item) && !item.formGroup.value.minusOverstockedStoreInventory"
                                            [class.kt-checkbox--solid]="item.formGroup.value.minusOverstockedStoreInventory">
                                            <input type="checkbox" [checked]="allSelected(item.overstockedStoresFormGroup)"
                                                (click)="includeAllOverstockedStores($event, item)">Include All
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                                <div *ngFor="let store of stores.getAll()"
                                    class="my-1 p-2 selectable border rounded-3 cursor-pointer"
                                    [class.not-allowed]="!item.storesFormGroup.value[store.id]"
                                    [class.selected]="item.overstockedStoresFormGroup.value[store.id]"
                                    (click)="setOverstockStore(item, store.id)">
                                    <div class="d-flex">{{store.name}}
                                        <i class="ml-auto fa" [class.kt-font-brand]="!item.overstockedStoresFormGroup.value[store.id]"
                                            [ngClass]="item.overstockedStoresFormGroup.value[store.id] ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                                    </div>
                                    <div class="text-dark strong">{{-item.overstockedStores.get(store.id) || 0 | number}}</div>
                                </div>
                            </ng-container>
                            <div class="my-2 p-3 selectable d-flex border rounded-3" [class.selected]="item.data.included">
                                <div>
                                    <div>Total units to order</div>
                                    <div class="text-dark strong">{{item.data.addedQuantity || item.totalReorder | number}}</div>
                                </div>
                                <div class="ml-auto">
                                    <button class="btn btn-sm btn-brand strong rounded-3" type="button" (click)="toggleInclude(item)">
                                        <i class="fa" [ngClass]="item.data.included ? 'fa-check' : 'fa-plus'"></i>
                                        Include{{item.data.included ? 'd' : ''}}
                                    </button>
                                </div>
                            </div>
                            <div class="py-1 d-flex">
                                <span class="kt-label-font-color-1">Cost</span>
                                <span class="ml-auto text-dark strong">{{(item.data.addedQuantity || item.totalReorder) * item.data.pricePlus | currency}}</span>
                            </div>
                            <div class="py-1 d-flex" *ngIf="item.data.cbm">
                                <span class="kt-label-font-color-1">CBM</span>
                                <span class="ml-auto text-dark strong">{{item.data.cbm * (item.data.addedQuantity || item.totalReorder) | number:'1.0-2'}}</span>
                            </div>
                            <button *ngIf="!item.showLocation" class="btn btn-sm btn-brand rounded-3 mt-2"
                                (click)="closeCal(item)">Done</button>
                            <button *ngIf="!item.showLocation" class="btn btn-sm btn-secondary rounded-3 mt-2"
                                (click)="closeCal(item, true)">Cancel</button>
                        </div>
                    </div>
                    <div class="kt-portlet kt-portlet--height-fluid">
                        <div class="kt-portlet__body bold h-100">
                            <div class="py-1 text-dark">
                                Total {{showPacks ? 'pack' : 'unit'}}s in <span class="strong">{{totalDays(item) | number}}</span> days
                                <span class="right strong">{{showQuantity(item, item.data.hasSubRule ? item.data.orders : totalUnits(item)) | number}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.formGroup.value.outOfStock">
                                <span class="kt-label-font-color-1">Adjust by in stock Avg.</span>
                                <span class="right text-dark strong">{{avgInStock(item) | percent}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.formGroup.value.buyBox">
                                <span class="kt-label-font-color-1">Adjust by Buy Box Avg.</span>
                                <span class="right text-dark strong">{{avgBuyBox(item) | percent}}</span>
                            </div>
                            <div class="border-bottom my-2"></div>
                            <div class="py-1 text-dark strong">
                                Avg. per day / total days
                                <span class="right">{{showQuantity(item, item.data.hasSubRule ? item.data.orders : totalOrders(item)) / totalDays(item) | number:'1.0-1'}} x {{ item.formGroup.value.totalDays || item.data.orderFor || item.totalOrderFor }}</span>
                            </div>
                            <div class="py-1" *ngIf="data.parentKey">
                                <span class="kt-label-font-color-1">Fraction</span>
                                <span class="right text-dark strong">{{item.data.fraction || 1 | number}}</span>
                            </div>
                            <div class="py-1 d-flex">
                                <span class="kt-label-font-color-1">Quantity needed</span>                    
                                <span class="ml-auto text-dark strong">{{ showQuantity(item, item.data.hasSubRule ? item.data.reorderRaw : totalOrders(item)) | number:'1.0-1'}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.formGroup.value.minusStoreInventory">
                                <span class="kt-label-font-color-1">Used Store Inventory</span>
                                <span class="right text-dark strong">{{-item.usedRealtime || 0 | number}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.formGroup.value.minusOverstockedStoreInventory">
                                <span class="kt-label-font-color-1">Overstocked Store Inventory</span>
                                <span class="right text-dark strong">{{-item.overstockedStoreInventory || 0 | number}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.formGroup.value.minusStoreInventory">
                                <span class="kt-label-font-color-1">Total Store Inventory</span>
                                <span class="right text-dark strong">{{item.totalRealtime || 0 | number}}</span>
                            </div>
                            <div class="py-1" *ngIf="item.data.adjustment">
                                <span class="kt-label-font-color-1">Adjustment of <span class="text-dark strong">{{item.data.adjustment | percent}}</span></span>
                                <span class="right text-dark strong">{{item.data.adjustment > 0 ? '+' : ''}}{{calculateAdjustment(item) | number}}</span>
                            </div>
                            <div class="py-1 kt-label-font-color-1" *ngIf="getTotalAdjustment(item)">
                                <span>Listings adjustments</span>
                                <span class="right strong">
                                    {{getTotalAdjustment(item) | number}}
                                </span>
                            </div>
                            <div class="py-1 d-flex w-100" [formGroup]="item.formGroup" *ngIf="item.data.manualEntry">
                                <span class="kt-label-font-color-1">Manual entry</span>
                                <span class="ml-auto text-dark strong">{{item.data.manualEntry < 0 ? '' : '+'}}{{item.data.manualEntry | number}}</span>
                            </div>
                            <div class="py-1 kt-label-font-color-1" *ngIf="getTotalManualEntry(item)">
                                <span>Listings manual entries</span>
                                <span class="right strong">
                                    {{getTotalManualEntry(item) | number}}
                                </span>
                            </div>
                            <div class="my-1"></div>
                            <button class="btn btn-sm btn-outline-secondary rounded-3 mt-auto"
                                (click)="modifyCal(item)">Modify calculation</button>
                            <div class="my-2 p-3 selectable d-flex border rounded-3" [class.selected]="item.data.included">
                                <div>
                                    <div>Total units to order</div>
                                    <div class="text-dark strong">{{item.data.addedQuantity || item.totalReorder | number}}</div>
                                </div>
                                <div class="ml-auto">
                                    <button class="btn btn-sm btn-brand strong rounded-3" type="button" (click)="toggleInclude(item)">
                                        <i class="fa" [ngClass]="item.data.included ? 'fa-check' : 'fa-plus'"></i>
                                        Include{{item.data.included ? 'd' : ''}}
                                    </button>
                                </div>
                            </div>
                            <div class="py-1">
                                <span class="kt-label-font-color-1">Cost</span>
                                <span class="right text-dark strong">{{(item.data.addedQuantity || item.totalReorder) * item.data.pricePlus | currency}}</span>
                            </div>
                            <div class="py-1" *ngIf="main?.cbm">
                                <span class="kt-label-font-color-1">CBM</span>
                                <span class="right text-dark strong">{{main.cbm * (item.data.addedQuantity || item.totalReorder) | number:'1.0-2'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="row kt-margin-t-10" *ngIf="data.total > data.pageSize">
    <div class="col-sm-12 col-md-5">
        <ngb-pagination [collectionSize]="data.total" [(page)]="data.page" [pageSize]="data.pageSize"
            (pageChange)="loadData()" [maxSize]="6" [rotate]="true"></ngb-pagination>
    </div>
    <div class="col-sm-12 col-md-7 dataTables_length kt-align-right" id="kt_table_1_length">
        <label>
            <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="data.pageSize"
                (change)="loadData()">
                <option [ngValue]="10" selected>10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
            </select>
            &nbsp;
            Page {{data.page}} of {{math.ceil((data.total / data.pageSize) || 0)}} ({{data.total}} items)
        </label>
        <div class="dataTables_info" role="status" aria-live="polite"></div>
    </div>
</div>
<div [class.shadow]="showShadow"></div>